"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentInformationPage = PaymentInformationPage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const PaymentInformation_1 = require("./PaymentInformation");
function PaymentInformationPage() {
    const params = (0, react_router_1.useParams)();
    const { invoiceId } = react_1.default.useMemo(() => ({
        invoiceId: Number(params.invoiceId),
    }), [params]);
    return (0, jsx_runtime_1.jsx)(PaymentInformation_1.PaymentInformation, { invoiceId: invoiceId });
}
exports.default = PaymentInformationPage;
